import { Fragment } from "react";
import usePage from "../../hooks/usePage";
import CityInquiry from "./CityInquiry";
import Menu from "../../modules/public/menu/menu";
import Footer from "../../modules/public/footer/footer";

const CityInquiryPage = () => {
  const { pageSliders, pageImage, pageText } = usePage();

  return (
    <Fragment>
      <Menu />

      {pageSliders}
      {pageText}

      <CityInquiry />

      {pageImage}

      <Footer />
    </Fragment>
  );
};

export default CityInquiryPage;
